import style from './cpNoData.module.scss';

function CpNoData() {
    return <div className={style.cpNoData}>這邊還是空空的</div>;
}
export default CpNoData;
